import type React from 'react';
import { useFormContext } from 'react-hook-form';

import VNSwitch from '../VNSwitch/VNSwitch';

type Props = {
  title?: string | React.ReactNode;
  actions?: React.ReactNode;
  main?: boolean;
  description?: string;
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
  enableSwitch?: string; // name of the switch to enable/disable the portlet content
  disabledSwitch?: boolean; // if true, the switch is disabled
  subPortlet?: boolean; // simplified styling for nested portlets
};

const VNPortlet = ({
  title = '',
  actions,
  main = false,
  description = '',
  className = '',
  style,
  children,
  enableSwitch,
  disabledSwitch = false,
  subPortlet = false,
}: Props) => {
  const methods = useFormContext();
  const watch = methods != null ? methods.watch : null; // aalt VNPortlet can be used outside form context
  const isEnabled = watch != null && enableSwitch ? watch(enableSwitch) : true;

  return (
    <div
      className={`vn-portlet ${className} ${isEnabled ? 'portlet-enabled' : ''} ${subPortlet ? 'sub-portlet' : ''}`}
      style={style}
    >
      {!main && title && (
        <div className="portlet-header">
          <div className="portlet-title">
            <span className={disabledSwitch ? 'Mui-disabled' : ''}>{title}</span>
            {description && <h3>{description}</h3>}
          </div>
          {actions && <div className="portlet-actions">{actions}</div>}
          {enableSwitch && (
            <div className="portlet-actions">
              <VNSwitch name={enableSwitch} label="" disabled={disabledSwitch} />
            </div>
          )}
        </div>
      )}
      {main && (
        <div className="main-title">
          <span>{title}</span>
        </div>
      )}
      {isEnabled && <div className="container">{children}</div>}
    </div>
  );
};

export default VNPortlet;
